module.exports = __webpack_public_path__ + "img/addons.9ba361a.svg";